"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingEventContentType = void 0;
/**
 * Sent as a property named content_type
 *
 * Reflects the type of thing tracked, usually identified by a further content_id event parameter
 */
var TrackingEventContentType;
(function (TrackingEventContentType) {
    TrackingEventContentType["Document"] = "document";
    TrackingEventContentType["Authentication"] = "authentication";
    TrackingEventContentType["Members"] = "members";
    TrackingEventContentType["Settings"] = "settings";
    TrackingEventContentType["Page"] = "page";
})(TrackingEventContentType || (exports.TrackingEventContentType = TrackingEventContentType = {}));
//# sourceMappingURL=models.js.map